import { render, staticRenderFns } from "./CopiedStatus.vue?vue&type=template&id=7ecf7092&scoped=true"
import script from "./CopiedStatus.vue?vue&type=script&lang=js"
export * from "./CopiedStatus.vue?vue&type=script&lang=js"
import style0 from "./CopiedStatus.vue?vue&type=style&index=0&id=7ecf7092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf7092",
  null
  
)

export default component.exports